import {
  OldTrackingConditions,
  OldTrackingConditionsTypes,
  TrackingConditions,
  TrackingConditionsTypes
} from 'consts/giConsts'
import useGaFlags from './useGaFlags'

export default () => {
  const { AIforHI } = useGaFlags()

  const getTrackingConditionsTypes = () => (AIforHI ? TrackingConditionsTypes : OldTrackingConditionsTypes)
  const getTrackingConditions = () => (AIforHI ? TrackingConditions : OldTrackingConditions)

  return {
    getTrackingConditionsTypes,
    getTrackingConditions
  }
}
